import {InsightsBookmarkParams} from 'common/types/reports/bookmark';

export const enum ChartDataEndpointPath {
  AverageWeeklyActiveUsersByProject = `avg_weekly_users_by_project`,
  WeeklyActiveUsers = `weekly_active_users`,
  MostActiveUsers = `most_active_users`,
  MostActiveUsersByProject = `most_active_users_by_project`,
  MostPopularDashboards = `most_popular_dashboard`,
  MostPopularReports = `most_popular_reports`,
  TotalViewedReports = `total_viewed_reports`,
  TotalReportUsage = `total_report_usage`,
  TotalReportUsageByProject = `total_report_usage_by_project`,
}

export const enum ChartName {
  WeeklyActiveUsers = `Weekly Active Users`,
  MostActiveUsers = `Most Active Users`,
  AverageActiveUsersByProject = `Active Users by Project`,
  FeatureUsage = `Feature Usage`,
  MostUsedFeatures = `Most Used Features`,
  MostPopularContent = `Most Popular Content`,
  FeatureUsageByProject = `Feature Usage by Project`,
}

export enum UsageAnalyticsContextTypes {
  Organization = `organization`,
  Project = `project`,
}

export interface DateRange {
  from_date: string;
  to_date: string;
}

// Used for Query string for Usage Analytics endpoints
export enum ChartDateRange {
  Weeks12 = `12weeks`,
  Days30 = `30days`,
  Months6 = `6months`,
}
export const ValidChartDateRanges = [ChartDateRange.Weeks12, ChartDateRange.Days30, ChartDateRange.Months6];
export enum Math {
  Unique = `unique`,
  Total = `Total`,
}

export interface Series {
  [key: string]: {
    // series key
    [key: string]:
      | string
      | TableSeriesData
      | WeeklyAvgUsersSeriesData
      | BarChartSeriesData
      | TotalReportUsageTableSeriesData
      | MostPopularSeriesData;
  };
}

export interface MostPopularSeriesData {
  creator_name: string;
  project_id: string;
  project_name: string;
  title: string;
  type: string;
  unique_view_count: number;
  can_view: boolean;
}

interface TableSeriesData {
  all: number;
  name: string;
  percentage: number;
}

interface TotalReportUsageTableSeriesData {
  data: {
    [reportName: string]: {
      all: number;
    };
  };
  name: string;
}

export interface WeeklyAvgUsersSeriesData {
  avg: number;
  name: string;
}

interface BarChartSeriesData {
  [key: string]: {
    all: number;
  };
}

export interface UsageAnalyticsApiResponse {
  computed_at: string;
  date_range: DateRange;
  headers: string[];
  series: Series;
  bookmark: InsightsBookmarkParams;
}
